module.exports = __webpack_public_path__ + "static/series_1200-5483a1dc4e96be7bc33d39e07fa77fe8.png";